import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const accordionSx = (isDark: boolean) => ({
  border: `1px solid ${isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)'}`,
  borderRadius: '12px !important',
  overflow: 'hidden',
  mb: 2,
  '&:before': { display: 'none' },
  '&.Mui-expanded': { mb: 2 },
  boxShadow: isDark ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.04)',
});

export const accordionSummarySx = (isDark: boolean) => ({
  background: isDark
    ? 'linear-gradient(135deg, rgba(30,36,68,0.7) 0%, rgba(22,28,52,0.5) 100%)'
    : 'linear-gradient(135deg, rgba(245,247,252,1) 0%, rgba(238,241,248,1) 100%)',
  minHeight: 56,
  '&.Mui-expanded': { minHeight: 56 },
  '& .MuiAccordionSummary-content': { alignItems: 'center', gap: 1.5 },
  '& .MuiAccordionSummary-content.Mui-expanded': { margin: '12px 0' },
});

export const PROJEKTKENNUNG_TOOLTIP =
  'Wird als Prefix an die Finding-Referenz-ID angehängt (z.B. ENBW-001, ENBW-002). Die Nummerierung steigt im Audit-Report je Finding automatisch hoch.';

export const FieldLabel: React.FC<{ label: string; tooltip: string; required?: boolean }> = ({
  label,
  tooltip,
  required,
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
    <Typography variant="body2" sx={{ fontWeight: 500 }}>
      {label}
      {required && ' *'}
    </Typography>
    <Tooltip title={tooltip} arrow placement="top">
      <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.disabled', cursor: 'help' }} />
    </Tooltip>
  </Box>
);
